import { useNavigate } from 'react-router-dom';

export default function TrainingPrograms() {
  const navigate = useNavigate();

  const programs = [
    {
      icon: 'ri-shield-check-line',
      image: 'https://public.readdy.ai/ai/img_res/9f5fcb6f84ded0d023f2bf4fd4e97fdc.jpg',
      title: 'Cybersecurity Fundamentals',
      duration: '8 weeks',
      level: 'Beginner to Intermediate',
      description: 'Master the essentials of cybersecurity including threat detection, risk management, and security protocols.',
      topics: ['Network Security', 'Threat Analysis', 'Security Protocols', 'Incident Response']
    },
    {
      icon: 'ri-bar-chart-box-line',
      image: 'https://readdy.ai/api/search-image?query=Data%20analytics%20visualization%20with%20colorful%20charts%20graphs%20and%20dashboard%20elements%20on%20dark%20background%2C%20modern%20business%20intelligence%20concept%20with%20teal%20and%20purple%20gradient%20accents%2C%20clean%20minimalist%20professional%20design&width=800&height=600&seq=data-analytics-training-002&orientation=landscape',
      title: 'Data Analytics & Visualization',
      duration: '10 weeks',
      level: 'Intermediate',
      description: 'Learn to analyze complex datasets and create compelling visualizations for data-driven decision making.',
      topics: ['Statistical Analysis', 'Data Mining', 'Tableau & Power BI', 'Predictive Modeling']
    },
    {
      icon: 'ri-cloud-line',
      image: 'https://readdy.ai/api/search-image?query=Cloud%20computing%20infrastructure%20with%20floating%20cloud%20icons%20and%20network%20connections%20on%20dark%20background%2C%20modern%20technology%20architecture%20with%20teal%20glowing%20elements%20and%20secure%20data%20flow%20visualization%2C%20minimalist%20professional%20style&width=800&height=600&seq=cloud-security-training-003&orientation=landscape',
      title: 'Cloud Security Architecture',
      duration: '12 weeks',
      level: 'Advanced',
      description: 'Design and implement secure cloud infrastructure across AWS, Azure, and Google Cloud platforms.',
      topics: ['Cloud Infrastructure', 'IAM & Access Control', 'Compliance', 'Security Automation']
    },
    {
      icon: 'ri-code-box-line',
      image: 'https://readdy.ai/api/search-image?query=DevSecOps%20engineering%20concept%20with%20code%20pipelines%20and%20security%20automation%20on%20dark%20background%2C%20modern%20software%20development%20workflow%20with%20teal%20and%20green%20accent%20colors%2C%20continuous%20integration%20deployment%20visualization%2C%20clean%20professional%20minimalist%20design&width=800&height=600&seq=devsecops-training-004&orientation=landscape',
      title: 'DevSecOps Engineering',
      duration: '10 weeks',
      level: 'Intermediate to Advanced',
      description: 'Integrate security practices into DevOps workflows with automated testing and continuous monitoring.',
      topics: ['CI/CD Security', 'Container Security', 'Infrastructure as Code', 'Security Testing']
    }
  ];

  const handleLearnMore = () => {
    navigate('/lms/course-catalog');
  };

  return (
    <section id="training-programs" className="py-20 bg-gray-900/30 backdrop-blur-sm">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" style={{ fontFamily: '"Space Grotesk", sans-serif' }}>
            Our Training Programs
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Comprehensive courses designed to advance your career in cybersecurity and data analytics
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {programs.map((program, index) => (
            <div 
              key={index}
              className="bg-gray-900 rounded-xl overflow-hidden border border-gray-800 hover:border-teal-500/50 transition-all duration-300 hover:shadow-lg hover:shadow-teal-500/10"
            >
              <div className="relative w-full h-48">
                <img 
                  src={program.image} 
                  alt={program.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/50 to-transparent"></div>
                <div className="absolute bottom-4 left-4 w-12 h-12 flex items-center justify-center bg-teal-500/90 rounded-lg backdrop-blur-sm">
                  <i className={`${program.icon} text-2xl text-white`}></i>
                </div>
              </div>

              <div className="p-8">
                <div className="mb-4">
                  <h3 className="text-2xl font-bold text-white mb-2">{program.title}</h3>
                  <div className="flex flex-wrap gap-4 text-sm text-gray-400">
                    <span className="flex items-center gap-2">
                      <i className="ri-time-line text-teal-400"></i>
                      {program.duration}
                    </span>
                    <span className="flex items-center gap-2">
                      <i className="ri-bar-chart-line text-teal-400"></i>
                      {program.level}
                    </span>
                  </div>
                </div>

                <p className="text-gray-400 mb-6 leading-relaxed">
                  {program.description}
                </p>

                <div className="mb-6">
                  <h4 className="text-sm font-semibold text-white mb-3">Key Topics:</h4>
                  <div className="grid grid-cols-2 gap-2">
                    {program.topics.map((topic, idx) => (
                      <div key={idx} className="flex items-center gap-2 text-sm text-gray-400">
                        <i className="ri-checkbox-circle-fill text-teal-500"></i>
                        <span>{topic}</span>
                      </div>
                    ))}
                  </div>
                </div>

                <button 
                  onClick={handleLearnMore}
                  className="w-full px-6 py-3 bg-teal-500 text-gray-900 rounded-lg hover:bg-teal-400 transition-colors cursor-pointer whitespace-nowrap font-semibold"
                >
                  Learn More
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}